import { common } from '@ocean/ui'
import {
  InfoListLayout,
  InfoListSeparator,
  InfoListRow,
  InfoListLabel,
  InfoListValue,
} from 'layouts/infoLists'
import { SectionArguments } from 'modules/simulatorTrainings/common/types/productSheet'

const { HTMLContent } = common

type BaseSectionProps = {
  title?: string
  content?: string
  sectionArguments: SectionArguments | null
}

const BaseSection: React.FC<BaseSectionProps> = props => {
  const { title = '', content, sectionArguments } = props
  const { space } = sectionArguments || {}

  function renderSpace(space: number) {
    if (!space) return <InfoListSeparator />
    return Array.apply(null, Array(space)).map((item, i) => <InfoListSeparator key={i} />)
  }

  return (
    <InfoListLayout labelWidth='230px'>
      <InfoListRow>
        <InfoListLabel>{title}</InfoListLabel>
        <InfoListValue>{content && <HTMLContent content={content} />}</InfoListValue>
      </InfoListRow>
      {renderSpace(Number(space))}
    </InfoListLayout>
  )
}

export default BaseSection
